module.exports = __webpack_public_path__ + "img/fiocruz.668c8bb6.svg";